var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 53,
    viewBox: "0 0 38 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9844 4.25C37.9844 3.82 37.9544 3.36002 37.8444 2.96002C37.4344 1.39002 36.4744 0.5 35.2244 0.5L4.87444 0.52002C4.31444 0.52002 3.79444 0.480029 3.27444 0.530029C1.47444 0.700029 0.0144444 2.28003 0.00444444 4.06003C0.00444444 13.86 -0.00555556 44.07 0.00444444 45.26C0.0244444 46.94 1.40444 48.54 3.10444 48.69C3.10444 48.69 5.11444 48.7 8.11444 48.71V44.33H5.80444C5.30444 44.3 4.95444 43.94 4.93444 43.49C4.92444 43.04 5.26444 42.66 5.75444 42.6C5.96444 42.57 6.18444 42.58 6.39444 42.58H34.1044C34.4144 42.58 34.7244 42.58 35.0344 42.54C36.5444 42.35 37.8344 41.17 37.9544 39.76C38.0244 38.96 37.9944 12.81 37.9844 4.25ZM31.1544 17.43C31.1544 18.2 30.5244 18.83 29.7344 18.83H8.34444C7.56444 18.83 6.92444 18.2 6.92444 17.43V8.44C6.92444 7.67 7.56444 7.04001 8.34444 7.04001H29.7344C30.5244 7.04001 31.1544 7.67 31.1544 8.44V17.43Z",
    fill: "#9919F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9344 43.17C36.5544 44.33 34.9444 44.37 33.3044 44.36C31.6644 44.35 26.4844 44.3401 21.0444 44.3401V48.7701C26.9644 48.7901 32.4844 48.8001 34.2444 48.7801C36.1144 48.7701 37.5844 47.64 37.9044 45.92C38.0644 45.06 37.9344 44.15 37.9344 43.17Z",
    fill: "#9919F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9645 44.3401V52.5001L14.5845 50.1201L10.1945 52.5001V44.3401H18.9645Z",
    fill: "#DEB5FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1644 14.4402H11.9244C11.0944 14.4402 10.4244 13.7702 10.4244 12.9402C10.4244 12.1102 11.0944 11.4402 11.9244 11.4402H26.1644C26.9944 11.4402 27.6644 12.1102 27.6644 12.9402C27.6644 13.7702 26.9944 14.4402 26.1644 14.4402Z",
    fill: "#DEB5FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResource);
export default __webpack_public_path__ + "static/media/resource.8c9a117dd2d340e6641f915b39adc9c4.svg";
export { ForwardRef as ReactComponent };